const GoodTimesFontText = ({ color = '#fff', fontSize = '1rem', children, showUnderline=false, styles }) => {
	return (
		<>
			<h4
				className="text-uppercase"
				style={{ fontFamily: 'Good Times', color, fontSize, letterSpacing: '0.125rem', fontWeight: '400', ...styles }}
				data-testid="goodTimesFontText"
			>
				{children}
			</h4>
			{showUnderline && <span className="d-block w-100" style={{ height: '0.2rem', backgroundColor: '#73CFF3' }} />}
		</>
	);
};

export default GoodTimesFontText;
